'use strict';

module.exports = {
  template: require('./salary-navigation.html'),
  controller: require('./salary-navigation.controller'),
  controllerAs: 'vm',

  bindings: {
    titleText: '@',
    leadText: '@'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-navigation/index.js
 ** module id = 234
 ** module chunks = 0
 **/